export const AD_ART_CONTEXT = 'assistedDesign';
// Style URL params eligible for the AD Test
export const ELIGIBLE_STYLES = [
  '136600',
  '141600',
  '161900',
  '170000',
  '176100',
  '176800',
  '186800',
  '192300',
  '192800',
  '194300',
  '196900',
  '197900',
  '205000',
  '208000',
  '211000',
  '213300',
  '237400',
  '241500',
  '241600',
  '241700',
  '244200',
  '244900',
  '250400',
  '257600',
  '271400',
  '273500',
  '304200',
  '308000',
  '322700',
  '331100',
  '334800',
  '345700',
  '364800',
  '405800',
  '417900',
  '560500',
  '160900',
  '204600',
  '208300',
  '210700',
  '223300',
  '241400',
  '271600',
  '289700',
  '306000',
  '336800',
  '352900',
  '406400',
  '169600',
  '204500',
  '325300',
  '402100',
  '285500',
  '331000',
  '1100',
  '4100',
  '5100',
  '107300',
  '112100',
  '119000',
  '124500',
  '131100',
  '157800',
  '166300',
  '168100',
  '176000',
  '176400',
  '176900',
  '188400',
  '193700',
  '193800',
  '207500',
  '208600',
  '209300',
  '211500',
  '213600',
  '213700',
  '241900',
  '242300',
  '251800',
  '271800',
  '286700',
  '287300',
  '290300',
  '304300',
  '307500',
  '334600',
  '337100',
  '353000',
  '361900',
  '380800',
  '380900',
  '385700',
  '401600',
  '406300',
  '407100',
  '122800',
  '180300',
  '208100',
  '223600',
  '228300',
  '305600',
  '308300',
  '353200',
  '421300',
  '565600',
  '174300',
  '185300',
  '289800',
  '290000',
  '381100',
  '334000',
  '4600',
  '15000',
  '116900',
  '136500',
  '137000',
  '161100',
  '165900',
  '172700',
  '172800',
  '175400',
  '182400',
  '197000',
  '198000',
  '205300',
  '208400',
  '213800',
  '237700',
  '242000',
  '242200',
  '242700',
  '248900',
  '251600',
  '251900',
  '252500',
  '253100',
  '270000',
  '271700',
  '274300',
  '290100',
  '299300',
  '300400',
  '330900',
  '337200',
  '355300',
  '355400',
  '364700',
  '381200',
  '405700',
  '406700',
  '479800',
  '560900',
  '565500',
  '287100',
  '297600',
  '365800',
  '373600',
  '560400',
  '223400',
  '322500',
  '345500',
  '269100',
  '123900',
  '124300',
  '150000',
  '151300',
  '151600',
  '166400',
  '169800',
  '187600',
  '196700',
  '197800',
  '200000',
  '202400',
  '214600',
  '225000',
  '229600',
  '237200',
  '240200',
  '245000',
  '271900',
  '272200',
  '299500',
  '306400',
  '306500',
  '308400',
  '337900',
  '340600',
  '353300',
  '356000',
  '361700',
  '364900',
  '365600',
  '407300',
  '480000',
  '480200',
  '175200',
  '175900',
  '203100',
  '225400',
  '225900',
  '304600',
  '307100',
  '480100',
  '190600',
  '289900',
  '331200',
  '4900',
  '6100',
  '7100',
  '116200',
  '124200',
  '150200',
  '153300',
  '161700',
  '172500',
  '173100',
  '179000',
  '179800',
  '180100',
  '188900',
  '200800',
  '204300',
  '205200',
  '206800',
  '214200',
  '231500',
  '237800',
  '241100',
  '247000',
  '264300',
  '264500',
  '264600',
  '274700',
  '297300',
  '304500',
  '307000',
  '307600',
  '322600',
  '336200',
  '337300',
  '337800',
  '338300',
  '338700',
  '355900',
  '356300',
  '362000',
  '362100',
  '362200',
  '385600',
  '387600',
  '406000',
  '407200',
  '560800',
  '169900',
  '239900',
  '300500',
  '373800',
  '401100',
  '565800',
  '567000',
  '567100',
  '212800',
  '419900',
  '152600',
  '165600',
  '172300',
  '175800',
  '186900',
  '192700',
  '194900',
  '197200',
  '203500',
  '211700',
  '213900',
  '224900',
  '238100',
  '239400',
  '241800',
  '246900',
  '263000',
  '270300',
  '286800',
  '290400',
  '330700',
  '336600',
  '336900',
  '337400',
  '337600',
  '338600',
  '345400',
  '416400',
  '421200',
  '566900',
  '172100',
  '187800',
  '191900',
  '196300',
  '330800',
  '333900',
  '336000',
  '337000',
  '371400',
  '405600',
  '304800',
  '336100',
  '366000',
  '200100',
  '565700',
  '91600',
  '100500',
  '107200',
  '113300',
  '116800',
  '125000',
  '138600',
  '138800',
  '160300',
  '172200',
  '172900',
  '174900',
  '191700',
  '191800',
  '192400',
  '199900',
  '204200',
  '214500',
  '223200',
  '237300',
  '237900',
  '239800',
  '240900',
  '257500',
  '273600',
  '287200',
  '289400',
  '304900',
  '336300',
  '361200',
  '361800',
  '365200',
  '373100',
  '406100',
  '416600',
  '421500',
  '99000',
  '198700',
  '204000',
  '206700',
  '256200',
  '269300',
  '334900',
  '336400',
  '262800',
  '407000',
  '421400',
  '401700',
  '285300',
  '322900',
  '129500',
  '160700',
  '160800',
  '166000',
  '166600',
  '175300',
  '175600',
  '175700',
  '181300',
  '187000',
  '193600',
  '203700',
  '204900',
  '209900',
  '210800',
  '212900',
  '213200',
  '223000',
  '240300',
  '256300',
  '257700',
  '259200',
  '271500',
  '289300',
  '299800',
  '299900',
  '304400',
  '305100',
  '305500',
  '306200',
  '341000',
  '344100',
  '356200',
  '365000',
  '365500',
  '373700',
  '381000',
  '383300',
  '392600',
  '397700',
  '401000',
  '420000',
  '137800',
  '166700',
  '281700',
  '289500',
  '305900',
  '322400',
  '337500',
  '335800',
  '287500'
];
